import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "reattach-modal" }
const _hoisted_2 = { class: "reattach-modal__search" }
const _hoisted_3 = {
  key: 0,
  class: "reattach-modal__close"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "reattach-modal__item-name" }
const _hoisted_6 = {
  key: 0,
  class: "reattach-modal__item-badge"
}
const _hoisted_7 = {
  key: 0,
  class: "reattach-modal__item-address"
}
const _hoisted_8 = {
  key: 0,
  class: "reattach-modal__empty"
}
const _hoisted_9 = {
  key: 1,
  class: "reattach-modal__error"
}

import {
	computed,
	nextTick,
	onMounted,
	ref,
	watch
} from "vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { financesStore } from "@/store/finances";
import { ReattachClient } from "@/models/interfaces/finances/counterparty-models";
import { debounce } from "lodash";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClientReattachDropdown',
  props: {
    counterpartyId: {},
    currentClientId: {},
    showCloseIcon: { type: Boolean }
  },
  emits: ["reattached", "close"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const finances = financesStore()

const $input = ref<typeof AppInput | null>(null)
const $body = ref<HTMLDivElement | null>(null)

const filter = ref('')
const clients = ref<ReattachClient[]>([])
const isListLoading = ref(false)
const isSubmitting = ref(false)
const errorText = ref('')

const loaderStyle = computed(() => ({
	'background-color': 'rgba(255, 255, 255, 0.5)'
}))

const onFetch = async () => {
	try {
		isListLoading.value = true
		clients.value = await finances.getReattachClients(filter.value)
	} catch (e) {
		console.error(e)
	} finally {
		isListLoading.value = false
	}
}

const onSearch = async () => {
	$body.value?.scrollTo({ top: 0 })
	await onFetch()
}

const debouncedSearch = debounce(onSearch, 500)

const onSelect = async (client: ReattachClient) => {
	if (client.id === props.currentClientId || isSubmitting.value) {
		return
	}

	try {
		errorText.value = ''
		isSubmitting.value = true
		const ok = await finances.reattachCounterparty({
			counterpartyId: props.counterpartyId,
			clientId: client.id,
		})
		if (ok) {
			emit('reattached')
		} else {
			isSubmitting.value = false
			errorText.value = 'Не удалось перепривязать контрагента'
		}
	} catch (e) {
		isSubmitting.value = false
		errorText.value = 'Не удалось перепривязать контрагента'
		console.error(e)
	}
}

watch(filter, (newVal, oldVal) => {
	if (newVal !== oldVal) {
		debouncedSearch()
	}
})

onMounted(async () => {
	try {
		await onFetch()
		await nextTick(() => $input.value?.focusInput())
	} catch (e) {
		console.error(e)
	}
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isListLoading.value || isSubmitting.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppInput, {
        ref_key: "$input",
        ref: $input,
        modelValue: filter.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
        class: "reattach-modal__search-input",
        placeholder: "Поиск клиента",
        "show-search-button": ""
      }, null, 8, ["modelValue"]),
      (props.showCloseIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(AppIcon, {
              name: "close",
              width: "20px",
              color: "#D2D2D2",
              "hover-color": "#499259",
              cursor: "pointer",
              title: "Закрыть",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "reattach-modal__header" }, [
      _createElementVNode("div", { class: "reattach-modal__header-title" }, " Клиенты ")
    ], -1)),
    _createElementVNode("div", {
      ref_key: "$body",
      ref: $body,
      class: "reattach-modal__body"
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(clients.value, (client) => {
        return (_openBlock(), _createElementBlock("div", {
          key: client.id,
          class: _normalizeClass({
					'reattach-modal__item': true,
					'reattach-modal__item--current': client.id === props.currentClientId
				}),
          onClick: ($event: any) => (onSelect(client))
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createTextVNode(_toDisplayString(client.name) + " ", 1),
            (client.id === props.currentClientId)
              ? (_openBlock(), _createElementBlock("span", _hoisted_6, "текущий"))
              : _createCommentVNode("", true)
          ]),
          (client.addressChain?.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(client.addressChain.join(', ')), 1))
            : _createCommentVNode("", true)
        ], 10, _hoisted_4))
      }), 128)),
      (!isListLoading.value && !clients.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, " Клиенты не найдены "))
        : _createCommentVNode("", true),
      (errorText.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(errorText.value), 1))
        : _createCommentVNode("", true)
    ], 512)
  ]))
}
}

})